import { Contract } from '../contracts/Contract';

export class Job {
    contractId = 0;

    contractSequence = 0;

    weekOfDate = '';

    requestedById = 0;

    foremanId = 0;

    startTime = '';

    companyId = '';

    companyName = '';

    workOrderNumber = '';

    jobCity = '';

    notes = '';

    resources = [];

    nonResources = [];

    overrides = [];

    employeeOverrideStartTimes = [];

    equipmentOverrideStartTimes = [];

    contract = new Contract();

    meetingLocation = null; // Address()

    jobLocation = null; // Address()

    hasAssignments = false;

    tenantSettings = null;

    jobMaterials = [];
}
